import {Notification} from '../../hooks/notifications/useNotifications';
import {NotificationItem} from './NotificationItem';

interface NotificationsListProps {
  unreadNotifications: Notification[];
  readNotifications: Notification[];
  tripUrls: Record<string, string>;
}

/**
 * Notifications list component with grouped sections (New/Earlier).
 * Renders unread and read notifications in separate sections.
 */
export function NotificationsList({
  unreadNotifications,
  readNotifications,
  tripUrls,
}: NotificationsListProps) {
  return (
    <div className="bg-surface">
      {unreadNotifications.length > 0 && (
        <div>
          <div className="px-4 py-2 bg-subtle border-b border-default">
            <p className="text-xs  text-muted uppercase">New</p>
          </div>
          {unreadNotifications.map((notification) => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              tripUrl={tripUrls[notification.tripId]}
            />
          ))}
        </div>
      )}

      {readNotifications.length > 0 && (
        <div>
          <div className="px-4 py-2 bg-subtle border-b border-default">
            <p className="text-xs  text-muted uppercase">Earlier</p>
          </div>
          {readNotifications.map((notification) => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              tripUrl={tripUrls[notification.tripId]}
            />
          ))}
        </div>
      )}
    </div>
  );
}
